import API from "@services/root/rootApi";
import {
  PreferenceGroup,
  HistoryPreferenceKey,
  Preferences_SavedSearches,
  UserPreferences,
  PreferenceKey,
  ListViewGlobalValues,
  ListViewPreferenceKey,
} from "./types";

const ROOT_URL = "/symphony-api/user/preferences/";

export const getAllUserPreferences = async () =>
  (
    await API.get<
      Array<UserPreferences<unknown, PreferenceGroup, PreferenceKey>>
    >(ROOT_URL)
  ).data;

const getUserPreferences = async <T = unknown,>(groupName: PreferenceGroup) =>
  await API.get<T>(`${ROOT_URL}${groupName}`);

export const createUserPreference = async <
  T,
  N extends PreferenceGroup,
  K extends PreferenceKey
>(
  groupName: PreferenceGroup,
  data: UserPreferences<T, N, K>
) => await API.post(`${ROOT_URL}${groupName}`, data);
export const updateUserPreference = async <
  T,
  N extends PreferenceGroup,
  K extends PreferenceKey
>(
  groupName: PreferenceGroup,
  key: PreferenceKey,
  data: UserPreferences<T, N, K>
) => await API.put(`${ROOT_URL}${groupName}/${key}`, data);
export const updateUserPreferences = async <
  T,
  N extends PreferenceGroup,
  K extends PreferenceKey
>(
  groupName: PreferenceGroup,
  data: UserPreferences<T, N, K>[]
) => await API.put(`${ROOT_URL}${groupName}`, data);

/**
 * Will need to add a lot more complexity if one day we saved the history of something else in that "history" group
 * But might as well start simple
 */
export const getSavedSearches = async (): Promise<string[]> => {
  const result = (
    await getUserPreferences<Preferences_SavedSearches[]>(
      PreferenceGroup.HISTORY
    )
  ).data.find((x) => x.key === HistoryPreferenceKey.SEARCH_HISTORY);
  if (result === undefined) return [];
  return result.value.savedSearches;
};

export const updateSavedSearches = async (savedSearches: string[]) => {
  const preferenceGroup = PreferenceGroup.HISTORY;
  const preference: Preferences_SavedSearches = {
    preferenceGroup: PreferenceGroup.HISTORY,
    key: HistoryPreferenceKey.SEARCH_HISTORY,
    value: {
      savedSearches,
    },
  };
  return await updateUserPreferences(preferenceGroup, [preference]);
};
